import React, { Component } from "react";

class AddSurvey extends Component {
  constructor(props) {
    super(props);
    this.state = {
      titulo: "",
      descripcion: "",
      fecha: "",
      tiempo: ""
    };
  }
  render() {
    return (
      <div className="container">
        <h1>Agregar encuesta</h1>
        <form action="/survey/add" method="post">
          <div className="form-group">
            <label>Título</label>
            <input
              type="text"
              name="titulo"
              className="form-control"
              required
            />
          </div>

          <div className="form-group">
            <label>Fecha control de publicación</label>
            <input type="date" name="fecha" className="form-control" required />
          </div>

          <div className="form-group">
            <label>Descripción</label>
            <textarea
              rows="4"
              cols="50"
              name="descripcion"
              className="form-control"
            />
            <small id="emailHelp" className="form-text text-muted">
              La descripción de la encuesta.
            </small>
          </div>

          <div className="form-group">
            <label>Tiempo</label>
            <input type="text" name="tiempo" className="form-control" />
            <small id="emailHelp" className="form-text text-muted">
              Tiempo aproximado para completar la encuesta. Ejemplo: 15 mins
            </small>
          </div>
          <br />

          <button type="submit" value="Submit" className="btn btn-primary">
            Siguiente
          </button>
        </form>
      </div>
    );
  }
}

export default AddSurvey;



// WEBPACK FOOTER //
// ./src/components/Survey/admin/AddSurvey.js